import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import Header from './components/Header';
import './App.css';
import FeaturedEvent from './components/FeaturedEvents.jsx';
import Calendar from './components/Calendar/Calendar';
import EloRanking from './components/EloRanking';
import LimitedTierlist from './components/LimitedTierlist/';
import Footer from './components/Footer';
import { Helmet } from 'react-helmet';
import darkTheme from './theme.js';
import { Analytics } from "@vercel/analytics/react";
import ErrorBoundary from './components/ErrorBoundary';
import AdminPanel from './components/Admin/AdminPanel';
import UserSettings from './components/Auth/UserSettings';
import Tracker from './components/Tracker';
import DeckDetailsPage from './components/Tracker/DeckDetailsPage';
import ArchetypeDetailsPage from './components/Tracker/ArchetypeDetailsPage';
import Scouting from './components/Scouting';
import PremiumRoute from './components/Auth/PremiumRoute';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Analytics />
        <Helmet>
          <title>playLorcana.pl - Kalendarz</title>
          <meta name="description" content="Kalendarz wydarzeń Disney Lorcana - śledź nadchodzące turnieje, spotkania i premiery związane z grą karcianą Disney Lorcana" />
          <meta name="keywords" content="Disney Lorcana, kalendarz wydarzeń, turnieje Lorcana, wydarzenia Disney Lorcana, playLorcana" />
          <meta property="og:title" content="playLorcana.pl - Kalendarz wydarzeń Disney Lorcana" />
          <meta property="og:description" content="Wszystkie najważniejsze wydarzenia Disney Lorcana w jednym miejscu" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://playlorcana.pl" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="playLorcana.pl - Kalendarz" />
          <meta name="twitter:description" content="Kalendarz wydarzeń Disney Lorcana - śledź nadchodzące turnieje, spotkania i premiery" />
          <link rel="canonical" href="https://playlorcana.pl" />
          {/* Favicon */}
          <link rel="icon" href="/favicon.ico" />
          <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
          <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
          <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
          <link rel="manifest" href="/site.manifest" />
          <meta name="theme-color" content="#000000" />
        </Helmet>
        <ThemeProvider theme={darkTheme}>
          <CssBaseline />
          <div className="app-container">
            <ErrorBoundary>
              <Routes>
                <Route path="/admin/*" element={<AdminPanel />} />
                <Route path="/settings" element={
                  <>
                    <Header />
                    <main className="main-content">
                      <UserSettings />
                    </main>
                    <Footer />
                  </>
                } />
                <Route path="/ranking" element={
                  <>
                    <Header />
                    <main className="main-content">
                      <EloRanking />
                    </main>
                    <Footer />
                  </>
                } />
                <Route path="/limited" element={
                  <>
                    <Header />
                    <main className="main-content">
                      <LimitedTierlist />
                    </main>
                    <Footer />
                  </>
                } />
                <Route path="/tracker" element={
                  <PremiumRoute>
                    <Header />
                    <main className="main-content">
                      <Tracker />
                    </main>
                    <Footer />
                  </PremiumRoute>
                } />
                <Route path="/tracker/:deckId" element={
                  <PremiumRoute>
                    <Header />
                    <main className="main-content">
                      <DeckDetailsPage />
                    </main>
                    <Footer />
                  </PremiumRoute>
                } />
                <Route path="/archetype/:archetypeId" element={
                  <PremiumRoute>
                    <Header />
                    <main className="main-content">
                      <ArchetypeDetailsPage />
                    </main>
                    <Footer />
                  </PremiumRoute>
                } />
                <Route path="/scouting" element={
                  <PremiumRoute>
                    <Header />
                    <main className="main-content">
                      <Scouting />
                    </main>
                    <Footer />
                  </PremiumRoute>
                } />
                <Route path="/*" element={
                  <>
                    <Header />
                    <main className="main-content">
                      <FeaturedEvent />
                      <Calendar />
                    </main>
                    <Footer />
                  </>
                } />
              </Routes>
            </ErrorBoundary>
          </div>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;